import { Injectable } from '@angular/core';
import { ReportFormat } from '../../types/api/export-files.types';
import { INITIAL_LABEL_DOWNLOAD } from '../../../shared/data/export-reports/constants';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  downloadBlob(blob: Blob, filename: string, format: ReportFormat): void {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement(INITIAL_LABEL_DOWNLOAD);
    anchor.href = url;
    anchor.download = `${filename}.${format}`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  }
}
